import "./UserHeader.css";

import { useState } from "react";

import { ArrowFullLeftDarkIcon, HelpCircleDarkIcon } from "../../../assets";
import { Avatar, Button, Divider, HelpCenter, NotificationBell } from "../..";
import { NavigationTooltip } from "../LeftNavigation/components";
import { ProfileMenu } from "../ProfileMenu";
import { ProfileMenuItem } from "../ProfileMenuItem";
import { useUserHeader } from "./useUserHeader";

interface UserHeaderProps {
  backButtonText?: string;
  handleBackClick?: () => void;
}

export const UserHeader = ({ backButtonText, handleBackClick }: UserHeaderProps): JSX.Element => {
  const [showHelpCenter, setShowHelpCenter] = useState(false);
  const { showProfileMenu, setShowProfileMenu, currentUserData, optionList, onOptionSelect, unreadNotificationCount } =
    useUserHeader();

  return currentUserData ? (
    <>
      <header className="UserHeader">
        {backButtonText ? (
          <Button
            className="UserHeaderBackButton"
            variant="secondary"
            text={backButtonText}
            icon={<ArrowFullLeftDarkIcon className="UserHeaderBackButtonIcon" />}
            iconPosition="left"
            onClick={handleBackClick}
          />
        ) : (
          <div />
        )}
        <NavigationTooltip text="Notifications">
          <NotificationBell unreadCount={unreadNotificationCount} variant="hub" />
        </NavigationTooltip>
        <NavigationTooltip text="Help">
          <Button
            className={`UserHeaderHelpButton ${showHelpCenter && "UserHeaderHelpButton_active"}`}
            onClick={() => setShowHelpCenter((prev) => !prev)}
            text=""
            icon={<HelpCircleDarkIcon />}
            hasNoPadding
            minWidth={false}
            variant="quinary"
            size="small"
          />
        </NavigationTooltip>
        <div>
          <Avatar
            imageSource={currentUserData?.avatar?.url}
            name={`${currentUserData?.firstName} ${currentUserData?.lastName}`}
            withName
            onClick={() => setShowProfileMenu(true)}
          />
          <ProfileMenu show={showProfileMenu} onClose={() => setShowProfileMenu(false)}>
            {optionList.map((option, index) => (
              <div key={option.id} className="ProfileMenuItemWrapper">
                <ProfileMenuItem profileMenuItem={option} onClick={() => onOptionSelect(option)} />
                {(index === 1 || index === 2) && <Divider className="ProfileMenuItemDivider" type="horizontal" />}
              </div>
            ))}
          </ProfileMenu>
        </div>
      </header>
      <HelpCenter show={showHelpCenter} onClose={() => setShowHelpCenter(false)} variant="hub" />
    </>
  ) : (
    <div />
  );
};
